import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD,
};

export default new Vuex.Store({
  state: {
    site: [],
    updates: [],
    info: [],
    artists: [],
    visit: [],
    press: [],
    credits: [],
  },
  getters: {
    getProjectByUID:
      (state) =>
      (uid, collection = state.projects) => {
        let i = collection.length;
        while (i--) {
          if (collection[i].uid === uid) {
            return collection[i];
          }
        }
      },
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              url: true,
              video: {
                query: "site.videos",
                select: {
                  url: "file.url"
                }
              }
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadUpdates({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('updates')",
            select: {
              title: true,
              uid: true,
              text: {
                query: "page.text.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_UPDATES", response.data.result);
        });
    },
    async loadVisit({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('visit')",
            select: {
              title: true,
              uid: true,
              text: {
                query: "page.text.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_VISIT", response.data.result);
        });
    },
    async loadCredits({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('credits')",
            select: {
              title: true,
              uid: true,
              text: {
                query: "page.text.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_CREDITS", response.data.result);
        });
    },
    async loadArtists({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('artists')",
            select: {
              title: true,
              uid: true,
              text: {
                query: "page.artists.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext",
                  bio: "structureItem.bio.kirbytext",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_ARTISTS", response.data.result);
        });
    },
    async loadPress({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('press')",
            select: {
              title: true,
              uid: true,
              text: "page.text.kirbytext",
              files: {
                query: "page.files",
                select: {
                  filename: "file.filename",
                  caption: "file.caption",
                  url: "file.url",
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_PRESS", response.data.result);
        });
    },
    async loadInfo({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('information')",
            select: {
              title: true,
              uid: true,
              text: "page.text.kirbytext",
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_INFO", response.data.result);
        });
    },
  },
  mutations: {
    SET_SITE(state, data) {
      state.site = data;
    },
    SET_UPDATES(state, data) {
      state.updates = data;
    },
    SET_VISIT(state, data) {
      state.visit = data;
    },
    SET_CREDITS(state, data) {
      state.credits = data;
    },
    SET_ARTISTS(state, data) {
      state.artists = data;
    },
    SET_PRESS(state, data) {
      state.press = data;
    },
    SET_INFO(state, data) {
      state.info = data;
    },
  },
});
